import { getErrorDetail } from "components/utility/utils";
import { fetchOrchidAPI } from "utils/api";

/**
 * Update orchid pro reminder
 */
export default async function putOrchidProReminderById(
  reminderId: number,
  nextReminder: AppointmentReminder,
  onBehalfOf?: string,
): Promise<AppointmentReminder> {
  const res = await fetchOrchidAPI(
    `/api/users/v1/appointment_reminders/${reminderId}${
      onBehalfOf ? `?on_behalf_of=${onBehalfOf}` : ""
    }`,
    {
      method: "PUT",
      body: JSON.stringify(nextReminder),
    },
  );
  if (!res.ok) {
    throw new Error(getErrorDetail(await res.text()));
  }

  return res.json();
}
